import { useEffect, useState } from "react";

// Profilbild mit neutralem Standard-Avatar (Silhouette), falls keins hinterlegt ist
// oder das Bild nicht geladen werden kann.
export function Avatar({ url, name, size = 32, className = "" }: { url?: string | null; name?: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const style = { width: size, height: size };
  if (url && !failed) {
    return <img src={url} alt={name ? `Profilbild ${name}` : "Profilbild"} style={style} onError={() => setFailed(true)}
      className={`shrink-0 rounded-full object-cover ring-1 ring-[var(--line)] ${className}`} />;
  }
  return (
    <span style={style} aria-hidden="true" className={`grid shrink-0 place-items-center overflow-hidden rounded-full bg-[var(--teal-light)] ${className}`}>
      <svg viewBox="0 0 32 32" className="h-full w-full">
        <circle cx="16" cy="12.5" r="5.5" fill="var(--teal-mid, #7CC8D2)" />
        <path d="M5.5 28c1.6-5.2 5.6-8 10.5-8s8.9 2.8 10.5 8" fill="var(--teal-mid, #7CC8D2)" />
      </svg>
    </span>
  );
}
